import {
	SiAmazonaws,
	SiAnaconda,
	SiAndroidstudio,
	SiArduino,
	SiBootstrap,
	SiChakraui,
	SiCplusplus,
	SiDocker,
	SiExpress,
	SiFirebase,
	SiGit,
	SiGithub,
	SiGitlab,
	SiGnubash,
	SiGo,
	SiJava,
	SiJavascript,
	SiLinux,
	SiMaterialui,
	SiMicrosoftazure,
	SiMongodb,
	SiMysql,
	SiNodedotjs,
	SiPhp,
	SiPostgresql,
	SiPostman,
	SiPython,
	SiReact,
	SiSpringboot,
	SiTailwindcss,
	SiTypescript,
	SiWindows,
	SiApachekafka,
	SiSplunk,
	SiGrafana,
	SiRedhatopenshift,
	SiKubernetes,
	SiJenkins,
	SiRedis,
	SiIntellijidea
} from 'react-icons/si'

import { FaBrain } from 'react-icons/fa'
import { MdLeaderboard, MdLightbulb, MdMessage } from 'react-icons/md'
import { RiTeamFill } from 'react-icons/ri'

/* =======================
   Programming Languages
======================= */
export const programming_languages = [
	{ id: 1, text: 'Java', icon: <SiJava />, color: '#F0931C' },
	{ id: 2, text: 'Go', icon: <SiGo />, color: '#79D4FD' },
	{ id: 3, text: 'Python', icon: <SiPython />, color: '#336D9D' },
	{ id: 4, text: 'JavaScript', icon: <SiJavascript />, color: '#EAD41C' },
	{ id: 5, text: 'TypeScript', icon: <SiTypescript />, color: '#2F72BC' },
	{ id: 6, text: 'C/C++', icon: <SiCplusplus />, color: '#00417B' },
	{ id: 7, text: 'SQL', icon: <SiPostgresql />, color: '#336791' },
	{ id: 8, text: 'Bash', icon: <SiGnubash />, color: '#262E34' },
	{ id: 9, text: 'PHP', icon: <SiPhp />, color: '#7377AD' }
]

/* =======================
   Backend & Distributed Systems
======================= */
export const backend_systems = [
	{ id: 1, text: 'Spring Boot', icon: <SiSpringboot />, color: '#6DB33F' },
	{ id: 2, text: 'Node.js', icon: <SiNodedotjs />, color: '#3C873A' },
	{ id: 3, text: 'Express.js', icon: <SiExpress />, color: '#000000' },
	{ id: 4, text: 'Apache Kafka', icon: <SiApachekafka />, color: '#27303B' }
]

/* =======================
   Frontend & UI
======================= */
export const frontend = [
	{ id: 1, text: 'React.js', icon: <SiReact />, color: '#61DAFB' },
	{ id: 2, text: 'Tailwind CSS', icon: <SiTailwindcss />, color: '#38BDF8' },
	{ id: 3, text: 'Material UI', icon: <SiMaterialui />, color: '#0081CB' },
	{ id: 4, text: 'Chakra UI', icon: <SiChakraui />, color: '#319795' },
	{ id: 5, text: 'Bootstrap', icon: <SiBootstrap />, color: '#7952B3' }
]

/* =======================
   Databases
======================= */
export const databases = [
	{ id: 1, text: 'MongoDB', icon: <SiMongodb />, color: '#47A248' },
	{ id: 2, text: 'MySQL', icon: <SiMysql />, color: '#00758F' },
	{ id: 3, text: 'PostgreSQL', icon: <SiPostgresql />, color: '#336791' },
	{ id: 4, text: 'Firebase', icon: <SiFirebase />, color: '#FFCA28' },
	{ id: 5, text: 'Redis', icon: <SiRedis />, color: '#DC382D' }
]

/* =======================
   Cloud & DevOps
======================= */
export const cloud_devops = [
	{ id: 1, text: 'AWS', icon: <SiAmazonaws />, color: '#FF9900' },
	{ id: 2, text: 'Azure', icon: <SiMicrosoftazure />, color: '#0078D4' },
	{ id: 3, text: 'OpenShift', icon: <SiRedhatopenshift />, color: '#EE0000' },
	{ id: 4, text: 'Docker', icon: <SiDocker />, color: '#2496ED' },
	{ id: 5, text: 'Kubernetes', icon: <SiKubernetes />, color: '#326CE5' },
	{ id: 6, text: 'Jenkins', icon: <SiJenkins />, color: '#D24939' },
	{ id: 7, text: 'Linux', icon: <SiLinux />, color: '#FCC624' }
]

/* =======================
   Monitoring & Observability
    
======================= */
export const monitoring = [
	{ id: 1, text: 'Grafana', icon: <SiGrafana />, color: '#F59E0B' },
	{ id: 2, text: 'Splunk', icon: <SiSplunk />, color: '#FF5E00' }
]

/* =======================
   Artificial Intelligence
======================= */
export const artificial_intelligence = [
	{ id: 1, text: 'Multi-Agent Systems', icon: <FaBrain />, color: '#8B5CF6' },
	{ id: 2, text: 'Generative AI', icon: <FaBrain />, color: '#10B981' },
	{ id: 3, text: 'Agentic AI', icon: <FaBrain />, color: '#4F46E5' },
	{ id: 4, text: 'Retrieval-Augmented Generation', icon: <FaBrain />, color: '#F59E0B' },
	{ id: 5, text: 'Agentic Workflows', icon: <FaBrain />, color: '#EC4899' }
]

/* =======================
   Developer Tools
======================= */
export const developer_tools = [
	{ id: 1, text: 'Git', icon: <SiGit />, color: '#F05032' },
	{ id: 2, text: 'GitHub', icon: <SiGithub />, color: '#181717' },
	{ id: 3, text: 'GitLab', icon: <SiGitlab />, color: '#FC6D26' },
	{ id: 4, text: 'Postman', icon: <SiPostman />, color: '#FF6C37' },
	{ id: 5, text: 'Android Studio', icon: <SiAndroidstudio />, color: '#3DDC84' },
	{ id: 6, text: 'Anaconda', icon: <SiAnaconda />, color: '#44A833' },
	{ id: 7, text: 'Arduino', icon: <SiArduino />, color: '#00979D' },
	{ id: 8, text: 'Windows', icon: <SiWindows />, color: '#0078D6' },
	{ id: 9, text: 'IntelliJ IDEA', icon: <SiIntellijidea />, color: '#000000' }
]

/* =======================
   Soft Skills
======================= */
export const soft_skills = [
	{ id: 1, text: 'Problem Solving', icon: <FaBrain />, color: '#8B5CF6' },
	{ id: 2, text: 'Analytical Thinking', icon: <MdLightbulb />, color: '#10B981' },
	{ id: 3, text: 'Communication', icon: <MdMessage />, color: '#4F46E5' },
	{ id: 4, text: 'Leadership', icon: <MdLeaderboard />, color: '#F59E0B' },
	{ id: 5, text: 'Teamwork', icon: <RiTeamFill />, color: '#EC4899' }
]
